import script from "./ProjectCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCard.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectCard.vue?vue&type=style&index=0&id=49955098&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49955098"]])

export default __exports__